import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NormasService } from '../_services/normas.service';
import { Norma } from '../_models/norma.model';
declare var jQuery:any;

import { EmpresasService } from '../_services/empresas.service';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'formularionormasmaestras',
  templateUrl: 'formularionormasmaestras.template.html',
  //providers:  [PreguntasService]
})
export class FormularioNormasMaestrasComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() idnorma: any;
  @Input() idmodulo: any;
  @Input() idarea: any;
  @Input() idbloque: any;
  @Input() copianorma: boolean;
  @Input() puedoeditar: boolean;

  @Output() onChangeNorma = new EventEmitter<boolean>();
  @Output() onCloseNorma = new EventEmitter<number>();

  filtroetiquetas: string = "xxxxxxx"; //forzamos así que no encuentre resultados en el listado
  filtroareas: string = "xxxxxxx"; //forzamos así que no encuentre resultados en el listado
  nuevaetiqueta: string = "";
  nuevaarea:string = "";

  id_norma: number;
  id_area: number;
  id_modulo: number;
  id_bloque: number;

  subscription: Subscription;

  listaAmbitos: any[];
  listaBloques: any[];
  listaareas: any[];
  listaModulos: any[];

  id_ambito: number;

  norma: Norma;
  normaInicial: Norma;
  idambitoselect: number = 1;

  totalcomentarios: number = 0;
  totalenlaces: number = 0;

  //form: FormGroup;

  selectListaAmbitos: any[];

  alertaguardado : boolean = false;

  etiquetanorma: string = "";
  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';


  mostrarmodal: boolean = false;
  nuevanorma:boolean = false;
  listaareasseleccionadas: any = [];
  areaseleccionada: any;
  areaSelected:number;

  listacomunidades: any = [];
  listaprovincias: any = [];
  listamunicipios: any = [];
  listamarcos: any = [];
  listapaises: any = [];
  listaetiquetas: any = [];
  listaetiquetasnorma: any = [];

  finalizado: boolean = false;
  revisado: boolean = false;
  realizaddo: any;

  mostrarEmpresasAfectadas:boolean = false;
  guardarCambios:boolean = false;
  mostrarModalFormularioArea:boolean = false;
  
  public optionsSelect: Select2Options
 
  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private empresasService: EmpresasService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){
    
    this.optionsSelect = {
      placeholder: "Select option...",
      allowClear: true,
      width: "80%"
    }

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });



  }

  cerrarNorma(destino:number){

    if (JSON.stringify(this.normaInicial) === JSON.stringify(this.norma)){
      this.alertaguardado = false;
      this.cerrarVentana(destino);
    }else{
      this.alertaguardado = true;
      jQuery(".columna").animate({scrollTop: 0}, 500);
    }
  }

  cerrarVentana(destino:number){
    this.onCloseNorma.emit(destino);
  }

  actualizaPadre(){
    this.onChangeNorma.emit(true);
  }

  cambioIdAmbito(valor){

  }

  cambioIdBloque(valor){
    //this.getListaAreas(valor);
  }

  cambioIdArea(valor){
    //this.getListaModulos(valor);
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['idnorma']){
      this.id_norma = changes['idnorma'].currentValue;
    }
    if (changes['idarea']){
      this.id_area = changes['idarea'].currentValue;
    }
    if (changes['idbloque']){
      this.id_bloque = changes['idbloque'].currentValue;
    }
    if (changes['idmodulo']){
      this.id_modulo = changes['idmodulo'].currentValue;
    }
    if (changes['copianorma']){
      this.copianorma = changes['copianorma'].currentValue;
    }

    this.getListaAmbitos();
    this.getListaAreas();
    //this.getListaBloques();


    this.getNorma(this.id_norma);
    this.getListaEtiquetasNorma();

    if (this.id_norma == 0){
      this.etiquetanorma = "Nueva norma maestra";
      this.nuevanorma = false;

    }else{
      this.etiquetanorma = "Editar norma maestra";
      this.nuevanorma = true;
    }
    if (!this.puedoeditar){
      this.etiquetanorma = "Norma maestra";
    }

    this.getListaComunidades();
    this.getListaMarcos();
    this.getListaPaises();

    this.getListaEtiquetas();

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  onSaveFinalizado(value:boolean){
    this.finalizado = value;
  }

  onSaveRevisado(value:boolean){
    this.revisado = value;
  }

  onSubmit(formulario: NgForm, event: Event){
    event.preventDefault;
    //console.log(formulario);

    if (this.finalizado){
      this.norma.finalizado = 1;
    }else{
      this.norma.finalizado = 0;
    }

    if (this.revisado){
      this.norma.revisado = 1;
    }else{
      this.norma.revisado = 0;
    }

    let norma: any;

    let cambiado: string = "no";

    if (
        this.norma.abr != this.normaInicial.abr ||
        this.norma.descripcion != this.normaInicial.descripcion ||
        this.norma.id_ambito != this.normaInicial.id_ambito ||
        this.norma.id_ambito_internacional != this.normaInicial.id_ambito_internacional ||
        this.norma.id_ambito_nacional != this.normaInicial.id_ambito_nacional ||
        this.norma.id_ambito_autonomico != this.normaInicial.id_ambito_autonomico ||
        this.norma.id_ambito_provincial != this.normaInicial.id_ambito_provincial ||
        this.norma.id_ambito_local != this.normaInicial.id_ambito_local ||
        this.norma.comentarios != this.normaInicial.comentarios ||
        this.norma.enlaces != this.normaInicial.enlaces ||
        this.norma.realizado != this.normaInicial.realizado ||
        this.norma.observacion_interna != this.normaInicial.observacion_interna
        
      ){
      cambiado = "si";
    }

    norma = {
      id_norma : this.norma.id_norma,
      abr: this.norma.abr,
      descripcion: this.norma.descripcion,
      id_ambito: this.norma.id_ambito,
      id_ambito_internacional: this.norma.id_ambito_internacional,
      id_ambito_nacional: this.norma.id_ambito_nacional,
      id_ambito_autonomico: this.norma.id_ambito_autonomico,
      id_ambito_provincial: this.norma.id_ambito_provincial,
      id_ambito_local: this.norma.id_ambito_local,

      comentarios: this.norma.comentarios,
      enlaces: this.norma.enlaces,
      id_copia: this.norma.id_copia,

      finalizado: this.norma.finalizado,
      revisado: this.norma.revisado,
      realizado: this.norma.realizado,
      observacion_interna: this.norma.observacion_interna,
      areas: this.listaareasseleccionadas,

      cambiado: cambiado
    };

    //console.log(JSON.stringify(norma));
    this.copianorma = false;

      this.normasService.setNormaMaestra(norma).subscribe(
        data => {
          if (data){
            console.log (data.json());

            let al: any = {
              "texto" : "Norma maestra guardada",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);

            this.updateNorma(data);

        //   this.mostrarmodal = true;
              this.mostrarEmpresasAfectadas = true;
              
          }
        }
      );
   
  }

  getListaAmbitos(){
    this.normasService.getListaAmbitos().subscribe(
      data => {
        if (data){
          this.listaAmbitos = data.json().lista;
        }
      }
    );
  }

  getListaAreas(){

    this.normasService.getListaAreas(0).subscribe(
      data => {
        if (data){
          this.listaareas = data.json().lista;
 
        }

      }
    );
  }

  updateAreasSeleccionadas(){

    this.listaareasseleccionadas = [];

      for (let area of this.norma.areas){

          this.listaareasseleccionadas.push(area);
          console.log(this.listaareasseleccionadas);

      }

  }

  anadirArea(id_area: any){

    if (id_area != 0){

      let encontrado: boolean = false;

      for (let a of this.listaareasseleccionadas){
        if (a.id_area == id_area){
          encontrado = true;
        }
      }

      if (!encontrado){
        for (let a of this.listaareas){
          if(a.id_area == id_area){
            this.listaareasseleccionadas.push(a);
          }
        }

      }

    }

    this.areaseleccionada = 0;

  }

  eliminarArea(area: any){

    let encontrado: number;

    for (let i = 0; i < this.listaareasseleccionadas.length; i++) {
      if (this.listaareasseleccionadas[i].id_area == area.id_area){
        encontrado = i;
      }
    }

    this.listaareasseleccionadas.splice(encontrado,1);

  }

  getListaEtiquetas(){
    this.normasService.getListaEtiquetasNorma().subscribe(
      data => {
        if (data){
          this.listaetiquetas = data.json().lista;
          console.log('***** etirquetas *****');
          console.log(this.listaetiquetas.length);
          console.log(this.listaetiquetas);
        }
      }
    );
  }

  getListaEtiquetasNorma(){
    this.normasService.getListaEtiquetasNorma(this.id_norma).subscribe(
      data => {
        if (data){
          this.listaetiquetasnorma = data.json().lista;
          console.log(this.listaetiquetasnorma);
        }
      }
    );
  }

  anadirEtiqueta(){
    if (this.nuevaetiqueta != ""){
      this.normasService.addEtiquetasNorma(this.id_norma, this.nuevaetiqueta).subscribe(
        data => {
          if (data){
            this.listaetiquetasnorma = data.json().lista;
            console.log(this.listaetiquetasnorma);
            this.nuevaetiqueta = "";
            this.filtroEtiquetas();
            this.getListaEtiquetas();
          }
        }
      );
    }
  }

  eliminarEtiqueta(id_etiqueta){
    this.normasService.delEtiquetasNorma(this.id_norma, id_etiqueta).subscribe(
      data => {
        if (data){
          this.listaetiquetasnorma = data.json().lista;
          console.log(this.listaetiquetasnorma);
          this.nuevaetiqueta = "";
          this.filtroEtiquetas();
        }
      }
    );
  }

  /*getListaBloques(){
    this.normasService.getListaBloques().subscribe(
      data => {
        if (data){
          this.listaBloques = data.json().lista;
        }
      }
    );
  }

  getListaAreas(id_bloque: number){

    this.normasService.getListaAreas(id_bloque).subscribe(
      data => {
        if (data){
          this.listaAreas = data.json().lista;

          if (id_bloque == this.normaInicial.id_bloque){
            this.norma.id_area = this.normaInicial.id_area;
          }else{
            this.norma.id_area = -1;
          }

          this.getListaModulos(this.norma.id_area);
        }

      }
    );
  }

  getListaModulos(id_area: number){

    this.normasService.getListaModulos(id_area).subscribe(
      data => {
        if (data){
          this.listaModulos = data.json().lista;

          if (id_area == this.normaInicial.id_area){
            this.norma.id_modulo = this.normaInicial.id_modulo;
          }else{
            this.norma.id_modulo = -1;
          }
        }

      }
    );
  }*/

  anadirComentario(){
    var nuevocomentario: any = { id_comentario: 0, comentario: "", visible: true };
    this.norma.comentarios.push(nuevocomentario);
  }

  anadirEnlace(){
    var nuevoenlace: any = { id_enlace: 0, enlace: "", visible: true };
    this.norma.enlaces.push(nuevoenlace);
  }

  borrarComentario(i){
    this.norma.comentarios[i].visible = false;
    this.norma.comentarios[i].comentario = "";
  }

  borrarEnlace(i){
    this.norma.enlaces[i].visible = false;
    this.norma.enlaces[i].enlace = "";
  }

  getNorma(id_norma){

    this.norma = new Norma();

    this.normasService.getNormaMaestra(id_norma).subscribe(
      data => {

        if (data){
          console.log(data.json());
          this.updateCampos(data,id_norma);
        }

      }
    );
  }

  updateCampos(data, id_norma){

    if (id_norma != 0){

      this.norma.abr = data.json().norma.abr;
      this.norma.descripcion = data.json().norma.descripcion;
      this.norma.id_ambito = data.json().norma.id_ambito;
      this.norma.id_ambito_internacional = data.json().norma.id_ambito_internacional;
      this.norma.id_ambito_nacional = data.json().norma.id_ambito_nacional;
      this.norma.id_ambito_autonomico = data.json().norma.id_ambito_autonomico;
      this.norma.id_ambito_provincial = data.json().norma.id_ambito_provincial;
      this.norma.id_ambito_local = data.json().norma.id_ambito_local;
      this.norma.id_norma = data.json().norma.id_norma;
      this.norma.id_modulo = data.json().norma.id_modulo;
      this.norma.id_bloque = data.json().norma.id_bloque;
      this.norma.id_area = data.json().norma.id_area;
      this.norma.comentarios = data.json().norma.comentarios;
      this.norma.enlaces = data.json().norma.enlaces;
      this.norma.ambito = data.json().norma.ambito;
      this.norma.bloque = data.json().norma.bloque;
      this.norma.area = data.json().norma.area;
      this.norma.modulo = data.json().norma.modulo;
      this.norma.areas = data.json().norma.areas;

      this.norma.ambitoNacional = data.json().norma.ambitoNacional;
      this.norma.ambitoInternacional = data.json().norma.ambitoInternacional;
      this.norma.ambitoProvincial = data.json().norma.ambitoProvincial;
      this.norma.ambitoLocal = data.json().norma.ambitoLocal;
      this.norma.ambitoAutonomico = data.json().norma.ambitoAutonomico;

      this.norma.finalizado = data.json().norma.finalizado;
      this.norma.revisado = data.json().norma.revisado;
      this.norma.realizado = data.json().norma.realizado;
      this.norma.observacion_interna = data.json().norma.observacion_interna;
 

      if (this.norma.finalizado == "0"){
        this.finalizado = false;
      }else{
        this.finalizado = true;
      }

      if (this.norma.revisado == "0"){
        this.revisado = false;
      }else{
        this.revisado = true;
      }

    }else{
      this.norma.id_area = this.id_area;
      this.norma.id_modulo = this.id_modulo;
      this.norma.id_bloque = this.id_bloque;
      this.norma.comentarios = [];
      this.norma.enlaces = [];
    }

    if (this.copianorma){
      this.norma.id_copia = this.norma.id_norma;
      this.norma.id_norma = 0;
      this.norma.abr = "(Copia) " + this.norma.abr;
      this.norma.descripcion = "(Copia) " + this.norma.descripcion;
    }

    this.totalcomentarios = this.norma.comentarios.length;
    this.totalenlaces = this.norma.enlaces.length;

    this.normaInicial = new Norma();
    this.normaInicial.abr = this.norma.abr;
    this.normaInicial.descripcion = this.norma.descripcion;
    this.normaInicial.id_ambito = this.norma.id_ambito;
    this.normaInicial.id_ambito_internacional = this.norma.id_ambito_internacional;
    this.normaInicial.id_ambito_nacional = this.norma.id_ambito_nacional;
    this.normaInicial.id_ambito_autonomico = this.norma.id_ambito_autonomico;
    this.normaInicial.id_ambito_provincial = this.norma.id_ambito_provincial;
    this.normaInicial.id_ambito_local = this.norma.id_ambito_local;
    this.normaInicial.id_norma = this.norma.id_norma;
    this.normaInicial.id_modulo = this.norma.id_modulo;
    this.normaInicial.id_bloque = this.norma.id_bloque;
    this.normaInicial.id_area = this.norma.id_area;
    this.normaInicial.comentarios = this.norma.comentarios;
    this.normaInicial.enlaces = this.norma.enlaces;
    this.normaInicial.ambito = this.norma.ambito;
    this.normaInicial.bloque = this.norma.bloque;
    this.normaInicial.area = this.norma.area;
    this.normaInicial.modulo = this.norma.modulo;
    this.normaInicial.areas = this.norma.areas;

    this.normaInicial.ambitoNacional = this.norma.ambitoNacional;
    this.normaInicial.ambitoInternacional = this.norma.ambitoInternacional;
    this.normaInicial.ambitoProvincial = this.norma.ambitoProvincial;
    this.normaInicial.ambitoLocal = this.norma.ambitoLocal;
    this.normaInicial.ambitoAutonomico = this.norma.ambitoAutonomico;

    this.normaInicial.finalizado = this.norma.finalizado;
    this.normaInicial.revisado = this.norma.revisado;
 //   this.normaInicial.realizado = this.norma.realizado;

    for (let i=0; i < this.norma.comentarios.length; i++){
      this.norma.comentarios[i].visible = true;
    }

    for (let i=0; i < this.norma.enlaces.length; i++){
      this.norma.enlaces[i].visible = true;
    }

    this.updateAreasSeleccionadas();

    if (this.norma.id_ambito_autonomico != 0){
      this.getListaProvincias(this.norma.id_ambito_autonomico);
    }

    if (this.norma.id_ambito_provincial != 0){
      this.getListaMunicipios(this.norma.id_ambito_provincial);
    }


  }

  updateNorma(data){

    this.norma = new Norma();

    this.updateCampos(data, this.id_norma);

    this.getListaAmbitos();
    this.getListaAreas();

  }

  editar(){
    this.puedoeditar = true;
    this.etiquetanorma = "Editar norma";
  }


  onChangeModal(event){
    this.mostrarmodal = false;
    this.actualizaPadre();
  }

  getListaMarcos(){

    let params = {
      action: "ListagetMarcos"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamarcos = data.json().lista;
          }
        }
    );

  }

  getListaPaises(){

    let params = {
      action: "ListagetPaises"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listapaises = data.json().lista;
          }
        }
    );

  }

  getListaComunidades(){

    let params = {
      action: "ListagetComunidades"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listacomunidades = data.json().lista;
          }
        }
    );

  }

  getListaProvincias(id_comunidad: any){

    let params = {
      action: "ListagetProvincias",
      id_comunidad: id_comunidad
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaprovincias = data.json().lista;
          }
        }
    );

  }

  getListaMunicipios(id_provincia: number){

    let params = {
      action: "ListagetMunicipios",
      id_provincia: id_provincia
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamunicipios = data.json().lista;
          }
        }
    );

  }

  filtroEtiquetas(){
    if (this.nuevaetiqueta.length > 2){
      this.filtroetiquetas = this.nuevaetiqueta;
    }else{
      this.filtroetiquetas = "xxxxxxx";
    }
  }

  eventHandler(event) {
    console.log(event, event.keyCode, event.keyIdentifier);
  }

  bajarRealizado(norma: any){
    norma.realizado =  +norma.realizado - 10 ;
    if (norma.realizado < 1){
      norma.realizado = 1;
    }
    
  }

  subirRealizado(norma: any){
    norma.realizado =  +norma.realizado + 10 ;
  
    if (norma.realizado  > 100){
      norma.realizado  = 100;
    }
    
  }


  onChangeModalEmpresasAfectadas(event){

    this.mostrarEmpresasAfectadas = false;
    if (event == 1){
      this.mostrarmodal = true;
      this.guardarCambios = true;
    }else{
      this.mostrarmodal = false;
      this.guardarCambios = false;
    }
    
  }

  filtroAreas(){
    if (this.nuevaarea.length > 2){
      this.filtroareas = this.nuevaarea;
    }else{
      this.filtroareas = "xxxxxxx";
    }

    console.log(this.filtroareas);
  }

  onAreaChange(event){
   
    console.log(event);

    this.areaSelected = event.value;
    this.anadirArea(event.value)
  }

  anadirNuevaArea(event){
    this.mostrarModalFormularioArea = true;

  //  console.log(event);
  }

  onAnadirNuevaAreaClose(event){
    console.log(event);
    this.mostrarModalFormularioArea = false;
    this.getListaAreas();

  /*  if (event.anadir == true){
      this.mostrarModalFormularioArea = false;
    }
    */
  }

}



// WEBPACK FOOTER //
// ./src/app/normas/formularionormasmaestras.component.ts